<!--<template>
	<div>
		<header>
			<div class="bloque-cabecera">
				<div class="logo"></div>
			</div>
		</header>
		<br />


		<header>
			<img src="img/formulario Rent 2 Rent/Logo_Movistar.png">
		</header>
		<div class="headerButton">
			<button class="btnTipo_3" id="izda">SOLICITAR REPARACIÓN</button>
			<button class="btnTipo_2" id="dcha">CONSULTAR REPARACIÓN</button>
		</div>

		<section class="texto_1">



			<p>Para reparar tu dispositivo, necesitamos que rellenes los datos que te solicitamos a continuación (los marcados con (*) son obligatorios).</p>
			<p>En un plazo máximo de 48 horas laborables desde que nos envíes, contactaremos contigo para ir a recoger tu dispositivo.</p>
			<p>La recogida y devolución del dispositivo no tienen costes asociados y la reparación, si tu dispositivo está en garantía, tampoco.</p>
			<p>En caso de no estar en garantía, te facilitaremos un presupuesto.</p>
		</section>

		<section class="frm">
			<div id="divResultado"></div>

			<h2>1. Datos de contacto</h2>

			<label>(*) Nombre y apellidos: </label>
			<input type="text" id="txtNombre" maxlength="100" required>

			<label>(*) DNI/CIF/TARJETA RESIDENTE/PASAPORTE: </label>
			<input type="text" id="txtDNI" maxlength="25" required>

			<label>(*) Número de Abonado: </label>
			<input type="text" id="txtAbonado" maxlength="9" required>

			<label>Teléfono de Contacto: </label>
			<input type="tel" id="txtTelefono" maxlength="15">

			<label>(*) Email: </label>
			<input type="email" id="txtEmail" maxlength="100" required>

			<label>(*) Dirección: </label>
			<input type="text" id="txtDireccion" maxlength="100" required>

			<label>(*) Código Postal: </label>
			<input type="number" id="txtCodpos" maxlength="7" required>

			<label>(*) Población: </label>
			<input type="text" id="txtPoblacion" maxlength="80" required>

			<h3>Horario de Contacto</h3>

			<label>(Cuando contactemos tiene que tener acceso al dispositivo)</label>

			<label>(*) Horario desde: </label>
			<select id="cmbHoraDesde" required>
				<option value=""></option>
				<option value="08:00">08:00</option>
				<option value="08:30">08:30</option>
				<option value="09:00">09:00</option>
				<option value="09:30">09:30</option>
				<option value="10:00">10:00</option>
				<option value="10:30">10:30</option>
				<option value="11:00">11:00</option>
				<option value="11:30">11:30</option>
				<option value="12:00">12:00</option>
				<option value="12:30">12:30</option>
				<option value="13:00">13:00</option>
				<option value="13:30">13:30</option>
				<option value="14:00">14:00</option>
				<option value="14:30">14:30</option>
				<option value="15:00">15:00</option>
				<option value="15:30">15:30</option>
				<option value="16:00">16:00</option>
				<option value="16:30">16:30</option>
				<option value="17:00">17:00</option>
				<option value="17:30">17:30</option>
				<option value="18:00">18:00</option>
				<option value="18:30">18:30</option>
				<option value="19:00">19:00</option>
				<option value="19:30">19:30</option>
				<option value="20:00">20:00</option>
			</select>

			<label>(*) Horario hasta: </label>
			<select id="cmbHoraHasta" required>
				<option value=""></option>
				<option value="08:00">08:00</option>
				<option value="08:30">08:30</option>
				<option value="09:00">09:00</option>
				<option value="09:30">09:30</option>
				<option value="10:00">10:00</option>
				<option value="10:30">10:30</option>
				<option value="11:00">11:00</option>
				<option value="11:30">11:30</option>
				<option value="12:00">12:00</option>
				<option value="12:30">12:30</option>
				<option value="13:00">13:00</option>
				<option value="13:30">13:30</option>
				<option value="14:00">14:00</option>
				<option value="14:30">14:30</option>
				<option value="15:00">15:00</option>
				<option value="15:30">15:30</option>
				<option value="16:00">16:00</option>
				<option value="16:30">16:30</option>
				<option value="17:00">17:00</option>
				<option value="17:30">17:30</option>
				<option value="18:00">18:00</option>
				<option value="18:30">18:30</option>
				<option value="19:00">19:00</option>
				<option value="19:30">19:30</option>
				<option value="20:00">20:00</option>
			</select>

			<label>Si quieres que tengamos en cuenta cualquier cuestión antes de ponernos en contacto contigo, por favor, indícanoslo aquí: </label>
			<textarea maxlength="200" id="txtObservaciones" style="height: 120px;"></textarea>

			<h2>2. Resumen de la avería</h2>

			<label>Número de Serie</label>
			<div class="input-container">
				<input type="text" id="txtSN" maxlength="20">
				<img class="icon" src="/img/formulario Rent 2 Rent/ico_ayuda.png" onclick="popupImgOpen('/img/formulario Rent 2 Rent/SN.jpg');">
			</div>

			<label>IMEI</label>
			<div class="input-container">
				<input type="text" id="txtIMEI" maxlength="20">
				<img class="icon" src="/img/formulario Rent 2 Rent/ico_ayuda.png" onclick="popupImgOpen('/img/formulario Rent 2 Rent/ejemplo Imei.png');">
			</div>

			<label>Familia*:</label>
			<select id="cmbTipoModelo" onchange="onchangeCmbTipoModelo()" required>
				<option value=""></option>
			</select>

			<label>Marca*:</label>
			<select id="cmbMarca" onchange="onchangeCmbMarca()" required>
				<option value=""></option>
			</select>

			<label>Modelo*:</label>
			<select id="cmbModelo" required>
				<option value=""></option>
			</select>

			<label>Color: </label>
			<input type="text" id="txtCOLOR" maxlength="100">

			<label>Descripción avería*: </label>
			<textarea maxlength="200" id="txtSintoma" required style="height: 120px;"></textarea>

			<div id="fotos"></div>

			<label>Albarán:</label>
			<input type="file" id="albaran" maxlength="100">


			<label>(*) La venta del dispositivo se ha efectuado con:</label>
			<select id="cmbDondeVenta" required>
				<option value=""></option>
				<option value="Entregada en mi domicilio">Entregada en mi domicilio</option>
				<option value="Recogida en la tienda">Recogida en la tienda</option>
			</select>

			<label>Fecha de Compra</label>
			<input type="date" id="txtFechaCompra">

			<div class="texto_2">
				<p>Este es un formulario específico para el caso en que quiera reparar su dispositivo.</p>
				<p>Si el equipo esta defectuoso en origen, debe realizar la solicitud dentro de los primeros 15 días desde la adquisición de su dispositivo y debe presentar el dispositivo en su embalaje original con todos los accesorios y manuales.</p>
				<p>* Deberá llamar al 1004 Si el dispositivo se ha dañado en el transporte o quiere desistir de la compra realizada y devolver el equipo, y solicitar la tramitación de un desistimiento.</p>
				<p>* Solo aplica para entregas en domicilio del cliente.</p>
			</div>

			<button class="tipo_1" onclick="btCondiciones_click()">LEER Y ACEPTAR CONDICIONES</button>
			<br><br><br><br>

		</section>


		<div class="modal" id="divModalImg">
			<div style="position: relative;">
				<span class="cerrarPopup" onclick="divModalImg.style.display = 'none'">&times;</span>
				<img id="imgPopUp" />
			</div>
		</div>

		<div class="modal" id="divCondiciones">
			<div class="card" style="width: 800px; background-color: white;">
				<div class="titulo">
					<span class="tituloTexto">CONDICIONES GENERALES DE LA ORDEN DE REPARACIÓN</span>
					<span class="tituloClose" onclick="divCondiciones.style.display = 'none'">&times;</span>
				</div>
				<div class="texto">
					<span class="azul">Telefónica Móviles España, S.A.U., en adelante “Movistar”, gestionará la reparación de tu dispositivo según las siguientes condiciones:</span>
					<ul>
						<li>Si lo has adquirido <b>en propiedad</b>: dispones de 3 años de garantía desde su entrega, conforme al Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el texto refundido de la Ley General para la Defensa de los Consumidores y Usuarios y otras leyes complementarias.</li>
						<li>Si disfrutas de él como parte del producto Fusión <b>en régimen de arrendamiento</b>: durante el mismo, tienes derecho a recibir un mantenimiento para su buen funcionamiento o a su sustitución por otro del mismo modelo o de similares características si no es posible su reparación y la avería no se debe a un mal uso por tu parte.</li>
						<li><b>En cualquier caso</b>: al firmar este documento, habilitas a Movistar o establecimientos autorizados por Movistar, a tramitar la reparación del dispositivo con el servicio técnico homologado del fabricante, según la normativa aplicable al servicio de reparación de aparatos de uso doméstico.</li>
					</ul>
					<span class="azul">Debes tener en cuenta que no están cubiertos, en ningún caso, los daños originados por: </span>
					<ul>
						<li>Un mal trato o uso negligente (ej.: caídas o circunstancias de uso distintas al uso ordinario y habitual).</li>
						<li>La manipulación del dispositivo por tu cuenta o por un tercero no autorizado.</li>
						<li>La instalación de programas no realizados o no aprobados por Movistar.</li>
						<li>Un caso fortuito (ej.: descarga atmosférica, incendio, inundación o variaciones excesivas de la red eléctrica).</li>
					</ul>
					<span class="azul">Tienes que entregarnos tu dispositivo cumpliendo estos requisitos:</span>
					<ul>
						<li>En su <b>caja original</b>: junto con su albarán de entrega donde conste su código de identificación (ej.: IMEI).</li>
						<li><b>Sin accesorios</b> (tapas de batería, punteros, tarjetas de memoria, SIM…): no nos responsabilizamos de su pérdida o deterioro.</li>
						<li><b>Sin información</b>: es tu obligación entregar el dispositivo sin ningún contendido. Antes de entregárnoslo, asegura que has guardado tus datos personales, fotos, vídeos y cualquier contenido valioso para ti. Actualizaremos el software y no nos hacemos responsables de la pérdida total o parcial de la información que pudieras tener en el dispositivo.</li>
						<li><b>Sin bloqueos</b>: tienes que entregarnos el dispositivo sin ningún código de seguridad que impida acceder al mismo (huella, reconocimiento facial, contraseña…). Si no, no nos responsabilizamos de las consecuencias de devolverte el dispositivo sin haberlo podido reparar.</li>
					</ul>
					<span class="azul">Si la reparación es incompatible con el régimen de garantía o de mantenimiento que te aplique o simplemente quieres reparar tu dispositivo:</span>
					<ul>
						<li>Te facilitaremos un <b>presupuesto de reparación</b> válido durante 30 días hábiles desde su entrega. Si lo aceptas, procederemos con la reparación y si lo rechazas, te facturaremos 5 € por gastos de gestión (6,05 con IVA, 5,35 con IGIC, 5,50 con IPSI Ceuta y 5,40 con IPSI Melilla.). Si no es reparable, te lo devolveremos sin coste.</li>
						<li>Incluiremos los <b>gastos de reparación o de gestión</b> en tu factura Movistar si ya eres cliente, y si aún no lo eres, tendrás que pagarlos mediante transferencia bancaria o ingreso en la cuenta que te indicarán en la tienda, o llamando al 91 696 97 68.</li>
						<li>Si la avería <b>no es reparable</b>, podrás ir a recoger tu dispositivo a la tienda sin ningún coste.</li>
					</ul>
					<span class="azul">Tratamiento de tus datos personales:</span>
					<ul>
						<li>Trataremos tus datos personales conforme a lo establecido en la Política de Privacidad de Movistar, cuya información básica se recoge aquí. Dispones de su contenido íntegro en: www.movistar.es/privacidad. Telefónica de España, S.A.U. y Telefónica Móviles España, S.A.U., del grupo Telefónica, son las empresas corresponsables del tratamiento de tus datos personales, según los productos o servicios que tengas contratados.</li>
						<li>Trataremos tus datos para la prestación del Servicio, así como para otras finalidades que, como cliente Movistar, nos permitas o autorices en los términos recogidos en la Política de Privacidad, en la que además se recoge toda la información necesaria para que puedas decidir sobre otros tratamientos que requieran tu consentimiento. Los datos personales necesarios que aportas en este acto para la ejecución del contrato, junto a los obtenidos con motivo de la prestación del Servicio, así como a través de los canales de atención y comercialización, se incluirán en ficheros informatizados de datos de carácter personal titularidad de Movistar.</li>
						<li>Adicionalmente a los tratamientos recogidos en la Política de Privacidad, al aceptar los presentes términos y condiciones de uso del Servicio, eres informado y autorizas a Movistar al tratamiento específico de los datos facilitados en estas condiciones de reparación, en concreto, tus datos de cliente y del dispositivo averiado, cuyo tratamiento es necesario para la prestación del servicio de reparación.</li>
						<li>Para cualquier finalidad prevista en nuestra política de privacidad, Movistar puede encargar el tratamiento a proveedores de confianza y a aquellos que realizan transferencias internacionales de datos en el ejercicio de sus funciones recogidos en www.movistar.es/privacidad/info-adicional. En este sentido, garantizamos la adopción de las medidas necesarias para asegurar el tratamiento confidencial de dichos datos.</li>
						<li>Si lo deseas, puedes ejercer los derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad mandándonos un email a TE_datos@telefonica.com con el asunto DATOS, enviando un escrito al Apartado de Correos 46155, 28080 Madrid, o llamándonos al número gratuito 224407.</li>
					</ul>

					<button onclick="btEnviar_click()">ACEPTAR CONDICIONES Y ENVIAR</button>
				</div>
			</div>
		</div>

		<div class="modal" id="divLoading">
			<div class="loader"></div>
		</div>



		<footer>
			<div style="height: 30px"></div>
			<div class="bloque-alerta">
				<span id="lblMensaje12"></span>
			</div>
		</footer>
	</div>
</template>

<script>
	import incidencia_formulario from "@/Modelos/IncidenciaFormulario";
	import comprobaciones from "@/plugins/comprobaciones.js";

	export default {
		//layout: "noZeleris",
		layout: "movistar",
		components: {
			inputFile: () => import("@/components/fusion/input-file"),
			menuPage: () => import("@/components/movistar/menu"),
		},
		created() {

		},

		data: () => ({

			itemsDondeVenta: ["Entregada en mi domicilio", "Recogida en la tienda"],
		}),

		watch: {

		},

		computed: {


		},

		methods: {

		},
	};
</script>

<style>
	.informacion {
		color: #869296;
		font-size: 20px;
	}

		.informacion:hover {
			color: rgb(78, 168, 0);
		}

	.condiciones .azulClaro {
		color: #A6DDFB;
	}

	.condiciones .azul {
		color: #019DF4;
	}

	.condiciones ul {
		padding-left: 20px;
		padding-bottom: 10px;
		list-style: none;
	}

		.condiciones ul li::before {
			content: "\2022";
			color: #019DF4;
			font-weight: bold;
			display: inline-block;
			width: 1em;
			margin-left: -1em;
		}
</style>-->


<template>
	<div>
		<header>
			<div class="bloque-cabecera">
				<div class="logo"></div>
			</div>
		</header>
		<br />

		<section>
			<div class="bloque-datos">
				<v-row justify="center">
					<v-col align="center" class="col-12">
						<menuPage></menuPage>
					</v-col>
				</v-row>
				<div class="bloque-datos-titulo">

					<p class="justifyLeft">
						Para reparar tu dispositivo, necesitamos que rellenes los datos que te solicitamos a continuación (los marcados con (*) son obligatorios).
					</p>
					<p class="justifyLeft">
						En un plazo máximo de 48 horas laborables desde que nos envíes, contactaremos contigo para ir a recoger tu dispositivo.
					</p>
					<p class="justifyLeft">
						La recogida y devolución del dispositivo no tienen costes asociados y la reparación, si tu dispositivo está en garantía, tampoco.
					</p>
					<p class="justifyLeft">
						En caso de no estar en garantía, te facilitaremos un presupuesto.
					</p>
				</div>
				<br />

				<div class="bloque-alerta">
					<span id="lblMensaje" style="color: #869296"></span>
				</div>
				<br />
				<div class="bloque-datos-campos">
					<v-alert v-if="incidencia != ''"
							 dense
							 outlined
							 prominent
							 text
							 :type="tipoTextoIncidencia">
						{{ incidencia }}
					</v-alert>
					<h2>1. Datos de contacto</h2>
					<div class="row-etiqueta">(*) Nombre y apellidos: </div>
					<div class="row-campos">
						<input v-model="formulario.metaData.nombreCliente"
							   name="txtNombre"
							   maxlength="40"
							   id="txtNombre"
							   tabindex="3"
							   class="text-datos"
							   type="text" />
						<span id="lblMensaje3"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.nombre"></span>
					</div>
					<div class="row-etiqueta">(*) DNI/CIF/TARJETA RESIDENTE/PASAPORTE</div>
					<div class="row-campos">
						<input v-model="localDNI"
							   name="txtDNI"
							   type="text"
							   id="txtDNI"
							   tabindex="14"
							   class="text-datos"
							   style="color: #6f737d" />
						<span id="lblMensaje14"
							  style="color: #ff0000"
							  v-html="errorDNI"></span>
					</div>
					<div class="row-etiqueta">(*) Número de Abonado: </div>
					<div class="row-campos">
						<input v-model="localAbonado"
							   name="txtAbonado"
							   maxlength="9"
							   id="txtAbonado"
							   tabindex="2"
							   class="text-datos"
							   type="tel" />
						<span id="lblMensaje2"
							  style="color: #ff0000"
							  v-html="errorAbonado"></span>
					</div>
					<div class="row-etiqueta">Teléfono de Contacto:</div>
					<div class="row-campos">
						<input v-model="localTelefono"
							   name="txtTelefono"
							   maxlength="9"
							   id="txtTelefono"
							   tabindex="1"
							   class="text-datos"
							   type="tel" />
						<span id="lblMensaje1"
							  style="color: #ff0000"
							  v-html="errorTelefono"></span>
					</div>
					<div class="row-etiqueta">(*) Email:</div>
					<div class="row-campos">
						<input v-model="localEmail"
							   name="txtEmail"
							   maxlength="60"
							   id="txtEmail"
							   tabindex="4"
							   class="text-datos"
							   type="email" />
						<span id="lblMensaje4"
							  style="color: #ff0000"
							  v-html="errorEmail"></span>
					</div>
					<div class="row-etiqueta">(*) Dirección:</div>
					<div class="row-campos">
						<input v-model="formulario.metaData.direccionCliente"
							   name="txtDireccion"
							   maxlength="80"
							   id="txtDireccion"
							   tabindex="6"
							   class="text-datos"
							   type="text"
							   style="color: #6f737d" />
						<span id="lblMensaje6"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.direccion"></span>
					</div>
					<div class="row-etiqueta">(*) Código Postal:</div>
					<div class="row-campos">
						<input v-model="formulario.metaData.cpCliente"
							   name="txtCodpos"
							   maxlength="7"
							   id="txtCodpos"
							   tabindex="7"
							   class="text-datos"
							   type="number"
							   style="color: #6f737d" />
						<span id="lblMensaje7"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.cp"></span>
					</div>
					<div class="row-etiqueta">(*) Población:</div>
					<div class="row-campos">
						<input v-model="formulario.metaData.poblacionCliente"
							   name="txtPoblacion"
							   maxlength="40"
							   id="txtPoblacion"
							   tabindex="8"
							   class="text-datos"
							   type="text"
							   style="color: #6f737d" />
						<span id="lblMensaje8"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.poblacion"></span>
					</div>
					<div class="row-etiqueta">
						<h3>Horario de Contacto</h3><br />(Cuando contactemos tiene que tener
						acceso al dispositivo)
					</div>
					<span id="lblMensaje9"
						  style="color: #ff0000"
						  v-html="erroresObligatorios.horarioContacto"></span>
					<div class="row-etiqueta">(*) Horario desde:</div>
					<div class="row-campos">
						<v-autocomplete dense
										clearable
										auto-select-first
										v-model="localHorarioDesde"
										:items="itemsHorariosDesde"
										name="txtHoraDesde"
										id="txtHoraDesde"
										tabindex="17"
										style="color: #6f737d"></v-autocomplete>
					</div>
					<div class="row-etiqueta">(*) Horario hasta:</div>
					<div class="row-campos">
						<v-autocomplete v-if="localHorarioDesde !== '' && localHorarioDesde !== undefined"
										dense
										clearable
										auto-select-first
										v-model="localHorarioHasta"
										:items="itemsHorariosHasta"
										name="txtHoraDesde"
										id="txtHoraDesde"
										tabindex="17"
										style="color: #6f737d"></v-autocomplete>
						<v-autocomplete v-else
										dense
										clearable
										auto-select-first
										v-model="localHorarioHasta"
										:items="[]"
										name="txtHoraDesde"
										id="txtHoraDesde"
										tabindex="17"
										style="color: #6f737d"></v-autocomplete>
					</div>
					<div class="row-etiqueta">
						Si quieres que tengamos en cuenta cualquier cuestión antes de ponernos en contacto contigo, por favor, indícanoslo aquí:
					</div>
					<div class="row-campos">
						<v-textarea auto-grow
									counter
									:maxlength="200"
									outlined
									v-model="observacionesContacto"></v-textarea>
					</div>
					<div class="row-etiqueta"><h2>2. Resumen de la avería</h2></div>


					<div class="row-etiqueta">Número de Serie</div>
					<div class="row-campos">
						<input v-model="formulario.metaData.sn"
							   name="txtSN"
							   maxlength="20"
							   id="txtSN"
							   tabindex="9"
							   class="text-datos"
							   type="text"
							   style="color: #6f737d" />
						<div style="display: inline; margin-left: -30px; padding-bottom: 30px">
							<img @click="modalSN = true"
								 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
								 alt="?" />
						</div>
					</div>
					<div class="row-etiqueta">IMEI</div>
					<div class="row-campos">
						<input v-model="formulario.metaData.imei"
							   name="txtIMEI"
							   maxlength="20"
							   id="txtIMEI"
							   tabindex="10"
							   class="text-datos"
							   type="text"
							   style="color: #6f737d" />
						<div style="display: inline; margin-left: -30px; padding-bottom: 30px">
							<img @click="modalIMEI = true"
								 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
								 alt="?" />
						</div>
					</div>
					<div class="row-etiqueta">Familia*:</div>
					<div class="row-campos">
						<div class="select">
							<select v-if="TiposModelos != null"
									v-model="pedirDesplegables.idTipoModelo"
									name="cmbTipoModelo"
									id="cmbTipoModelo"
									:disabled="TiposModelos.length == 1"
									@change="changeSelectFamilia"
									tabindex="11">
								<option v-for="tipoModelo in TiposModelos"
										:key="tipoModelo.ID"
										selected
										:value="tipoModelo.ID">
									{{ tipoModelo.DESCRIPCION }}
								</option>
							</select>
						</div>
						<span id="lblMensaje25"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.familia"></span>
					</div>
					<template v-if="pedirDesplegables.idTipoModelo !== null">
						<div class="row-etiqueta">Marca*:</div>
						<div v-if="pedirDesplegables.idTipoModelo != 0" class="row-campos">
							<!--pedirDesplegables.idTipoModelo != 1-->
							<div class="select">
								<select v-if="Fabricantes != null"
										v-model="pedirDesplegables.idMarca"
										name="cmbMarca"
										id="cmbMarca"
										@change="changeSelectMarca"
										tabindex="12">
									<option v-for="fabricante in Fabricantes"
											:key="fabricante.ID"
											:value="fabricante.ID">
										{{ fabricante.DESCRIPCION }}
									</option>
								</select>
							</div>
							<span id="lblMensaje25"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.marca"></span>
						</div>
					</template>
					<div v-else class="row-campos">
						<div class="row-etiqueta">Marca*:</div>
						<input v-model="formulario.metaData.marca"
							   name="txtMARCA"
							   type="text"
							   id="txtMARCA"
							   tabindex="14"
							   class="text-datos"
							   style="color: #6f737d" />
						<span id="lblMensaje25"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.marca"></span>
					</div>
					<template v-if="pedirDesplegables.idMarca !== null">
						<div class="row-etiqueta">Modelo*:</div>
						<div v-if="pedirDesplegables.idTipoModelo != 0" class="row-campos">
							<!--pedirDesplegables.idTipoModelo != 1  No muestra modelos Smartphone-->
							<div class="select">
								<select v-if="Modelos != null"
										v-model="formulario.idModelo"
										name="cmbModelo"
										id="cmbModelo"
										tabindex="13">
									<option v-for="modelo in Modelos"
											:key="modelo.ID"
											:value="modelo.ID">
										{{ modelo.DESCRIPCION }}
									</option>
								</select>
							</div>
							<span id="lblMensaje25"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.modelo"></span>
						</div>
					</template>
					<div v-else class="row-campos">
						<div class="row-etiqueta">Modelo*:</div>
						<input v-model="formulario.metaData.modelo"
							   name="txtMODELO"
							   type="text"
							   id="txtMODELO"
							   tabindex="14"
							   class="text-datos"
							   style="color: #6f737d" />
						<span id="lblMensaje25"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.modelo"></span>
					</div>
					<div class="row-etiqueta">Color:</div>
					<div class="row-campos">
						<input v-model="formulario.metaData.color"
							   name="txtCOLOR"
							   type="text"
							   id="txtCOLOR"
							   tabindex="14"
							   class="text-datos"
							   style="color: #6f737d" />
					</div>
					<div class="row-etiqueta"> <b>Descripción avería*:</b></div><!--(*) Por favor, indícanos brevemente qué le pasa a tu dispositivo:-->
					<div class="row-campos">
						<input v-model="formulario.linea.sintomaAveria"
							   name="txtSintoma"
							   id="txtSintoma"
							   tabindex="5"
							   class="text-datos"
							   type="email" />
						<span id="lblMensaje5"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.sintoma"></span>
					</div>

					<br />

					<div v-if=" pedirDesplegables.idTipoModelo !=null" class="row-etiqueta">


						Fotos*:
						<div class="requerimiento">
							<br /><br />
							<label>
								Por favor, adjunte las fotos del embalaje y del dispositivo. Consulte el icono ayuda (?) para ver las instrucciones sobre cómo deben hacerse las fotos. Si no se adjuntan todas las fotos requeridas, el formulario no podrá continuar y tendrá que empezar de nuevo.
							</label><br /><br />
						</div>

						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-etiqueta">Embalaje 1:</div>
						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" v-model="formulario.embalaje1" id="embalaje1" />

							<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" style="display: inline; margin-left: -30px; padding-bottom: 30px">
								<img v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" @click="modalEmbalaje1 = true"
									 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
									 alt="?" />
							</div>
							<span v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" id="lblMensaje3"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.embalaje1"></span>
						</div>

						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-etiqueta">Embalaje 2:</div>
						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" v-model="formulario.embalaje2" id="embalaje2" />

							<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" style="display: inline; margin-left: -30px; padding-bottom: 30px">
								<img v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" @click="modalEmbalaje2 = true"
									 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
									 alt="?" />
							</div>
							<span v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" id="lblMensaje4"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.embalaje2"></span>
						</div>

						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-etiqueta">Embalaje 3:</div>
						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" v-model="formulario.embalaje3" id="embalaje3" />

							<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" style="display: inline; margin-left: -30px; padding-bottom: 30px">
								<img v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" @click="modalEmbalaje3 = true"
									 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
									 alt="?" />
							</div>
							<span v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" id="lblMensaje5"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.embalaje3"></span>
						</div>

						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-etiqueta">Embalaje 4:</div>
						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" v-model="formulario.embalaje4" id="embalaje4" />

							<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" style="display: inline; margin-left: -30px; padding-bottom: 30px">
								<img v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" @click="modalEmbalaje4 = true"
									 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
									 alt="?" />
							</div>
							<span v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" id="lblMensaje6"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.embalaje4"></span>
						</div>

						<div v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" class="row-etiqueta">Dispositivo Encendido:</div>
						<div v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" v-model="formulario.dispositivo_encendido" id="dispositivo_encendido" />

							<div v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" style="display: inline; margin-left: -30px; padding-bottom: 30px">
								<img v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" @click="modalDispositivoEncendido = true"
									 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
									 alt="?" />
							</div>
							<span v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" id="lblMensaje7"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.dispositivo_encendido"></span>
						</div>

						<div v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" class="row-etiqueta">Dispositivo Apagado:</div>
						<div v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" v-model="formulario.dispositivo_apagado" id="dispositivo_apagado" />

							<div v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" style="display: inline; margin-left: -30px; padding-bottom: 30px">
								<img v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" @click="modalDispositivoApagado = true"
									 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
									 alt="?" />
							</div>
							<span v-if="pedirDesplegables.idTipoModelo == 19 || pedirDesplegables.idTipoModelo == 2 ||
                                    pedirDesplegables.idTipoModelo == 23 || pedirDesplegables.idTipoModelo == 21 ||
                                    pedirDesplegables.idTipoModelo == 3" id="lblMensaje8"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.dispositivo_apagado"></span>
						</div>

						<div v-if="pedirDesplegables.idTipoModelo == 216 || pedirDesplegables.idTipoModelo == 209 || pedirDesplegables.idTipoModelo == 211 ||
                                    pedirDesplegables.idTipoModelo == 210 || pedirDesplegables.idTipoModelo == 47 || pedirDesplegables.idTipoModelo == 205 ||
                                    pedirDesplegables.idTipoModelo == 183 || pedirDesplegables.idTipoModelo == 213 || pedirDesplegables.idTipoModelo == 206 ||
                                    pedirDesplegables.idTipoModelo == 203 || pedirDesplegables.idTipoModelo == 73 || pedirDesplegables.idTipoModelo == 164"
							 class="row-etiqueta">Dispositivo:</div>
						<div v-if="pedirDesplegables.idTipoModelo == 216 || pedirDesplegables.idTipoModelo == 209 || pedirDesplegables.idTipoModelo == 211 ||
                                    pedirDesplegables.idTipoModelo == 210 || pedirDesplegables.idTipoModelo == 47 || pedirDesplegables.idTipoModelo == 205 ||
                                    pedirDesplegables.idTipoModelo == 183 || pedirDesplegables.idTipoModelo == 213 || pedirDesplegables.idTipoModelo == 206 ||
                                    pedirDesplegables.idTipoModelo == 203 || pedirDesplegables.idTipoModelo == 73 || pedirDesplegables.idTipoModelo == 164" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo == 216 || pedirDesplegables.idTipoModelo == 209 || pedirDesplegables.idTipoModelo == 211 ||
                                    pedirDesplegables.idTipoModelo == 210 || pedirDesplegables.idTipoModelo == 47 || pedirDesplegables.idTipoModelo == 205 ||
                                    pedirDesplegables.idTipoModelo == 183 || pedirDesplegables.idTipoModelo == 213 || pedirDesplegables.idTipoModelo == 206 ||
                                    pedirDesplegables.idTipoModelo == 203 || pedirDesplegables.idTipoModelo == 73 || pedirDesplegables.idTipoModelo == 164"
										v-model="formulario.dispositivo" id="dispositivo" />
							<span v-if="pedirDesplegables.idTipoModelo == 216 || pedirDesplegables.idTipoModelo == 209 || pedirDesplegables.idTipoModelo == 211 ||
                                    pedirDesplegables.idTipoModelo == 210 || pedirDesplegables.idTipoModelo == 47 || pedirDesplegables.idTipoModelo == 205 ||
                                    pedirDesplegables.idTipoModelo == 183 || pedirDesplegables.idTipoModelo == 213 || pedirDesplegables.idTipoModelo == 206 ||
                                    pedirDesplegables.idTipoModelo == 203 || pedirDesplegables.idTipoModelo == 73 || pedirDesplegables.idTipoModelo == 164"
								  id="lblMensaje9"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.dispositivo"></span>
						</div>

						<div v-if="pedirDesplegables.idTipoModelo == 209" class="row-etiqueta">Caja Carga:</div>
						<div v-if="pedirDesplegables.idTipoModelo == 209" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo == 209" v-model="formulario.caja_carga" id="caja_carga" />
							<span v-if="pedirDesplegables.idTipoModelo == 209" id="lblMensaje10"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.caja_carga"></span>
						</div>

						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-etiqueta">Serial Number:</div>
						<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" class="row-campos">
							<input-file v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" v-model="formulario.serial_number" id="serial_number" />

							<div v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" style="display: inline; margin-left: -30px; padding-bottom: 30px">
								<img v-if="pedirDesplegables.idTipoModelo != 209 && pedirDesplegables.idTipoModelo != 212 &&
                                    pedirDesplegables.idTipoModelo != 214 && pedirDesplegables.idTipoModelo != 1 &&
                                    pedirDesplegables.idTipoModelo != 215 && pedirDesplegables.idTipoModelo !=null" @click="modalSN = true"
									 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
									 alt="?" />
							</div>
							<span id="lblMensaje11"
								  style="color: #ff0000"
								  v-html="erroresObligatorios.serial_number"></span>
						</div>

					</div>


					<div class="row-etiqueta">Albarán:</div>
					<div class="row-campos">
						<input-file v-model="formulario.albaran" />
						<span id="lblMensaje2"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.albaran"></span>
					</div>

					<div class="row-etiqueta">(*) La venta del dispositivo se ha efectuado con:</div>
					<div class="row-campos">
						<v-autocomplete dense
										clearable
										auto-select-first
										v-model="formulario.metaData.dondeVenta"
										:items="itemsDondeVenta"
										name="dondeVenta"
										id="txtHoraDesde"
										tabindex="17"
										style="color: #6f737d"></v-autocomplete>
						<span id="lblMensaje10"
							  style="color: #ff0000"
							  v-html="erroresObligatorios.dondeVenta"></span>
					</div>

					<div class="row-etiqueta">Fecha de Compra</div>
					<div class="row-campos">
						<input v-model="formulario.metaData.fechaCompra"
							   name="txtFechaCompra"
							   type="date"
							   id="txtFechaCompra"
							   tabindex="15"
							   class="text-datos"
							   style="color: #6f737d" />
					</div>

					<br /><br />
					<div class="requerimiento">

						<label>
							Este es un <strong>formulario específico</strong> para el caso en
							que quiera <strong>reparar su dispositivo</strong>.
						</label><br /><br />
						<label>
							Si el <strong>equipo esta defectuoso en origen</strong>, debe
							realizar la solicitud dentro de los primeros 15 días desde la
							adquisición de su dispositivo y debe presentar el dispositivo en
							su embalaje original con todos los accesorios y manuales.
						</label><br /><br />
						<label>
							<strong>* Deberá llamar al 1004</strong> Si el dispositivo se ha
							<strong>dañado en el transporte</strong> o quiere
							<strong>desistir de la compra realizada</strong> y devolver el
							equipo, y solicitar la tramitación de un desistimiento.
						</label><br /><br />
						<label>
							* Solo aplica para entregas en domicilio del cliente.
						</label>


					</div>
					<br />
					<br />
					<v-btn @click="comprobarCampos" color="#9be51a" x-large block>
						<span style="color:black; font-weight:bold">LEER Y ACEPTAR CONDICIONES</span>
					</v-btn>
					<br />
					<br />
				</div>
			</div>

			<!-- MODALES -->
			<v-dialog v-model="modalSN" max-width="800">
				<v-card>
					<v-img src="/img/formulario Rent 2 Rent/SN.jpg"></v-img>
				</v-card>
			</v-dialog>

			<v-dialog v-model="modalIMEI" max-width="800">
				<v-card>
					<v-img src="/img/formulario Rent 2 Rent/ejemplo Imei.png"></v-img>
				</v-card>
			</v-dialog>

			<v-dialog v-model="modalEmbalaje1" max-width="800">
				<v-card>
					<v-img src="/img/formulario Rent 2 Rent/Embalaje1.jpg"></v-img>
				</v-card>
			</v-dialog>

			<v-dialog v-model="modalEmbalaje2" max-width="800">
				<v-card>
					<v-img src="/img/formulario Rent 2 Rent/Embalaje2.jpg"></v-img>
				</v-card>
			</v-dialog>

			<v-dialog v-model="modalEmbalaje3" max-width="800">
				<v-card>
					<v-img src="/img/formulario Rent 2 Rent/Embalaje3.jpg"></v-img>
				</v-card>
			</v-dialog>

			<v-dialog v-model="modalEmbalaje4" max-width="800">
				<v-card>
					<v-img src="/img/formulario Rent 2 Rent/Embalaje4.jpg"></v-img>
				</v-card>
			</v-dialog>

			<v-dialog v-model="modalDispositivoEncendido" max-width="800">
				<v-card>
					<v-img src="/img/formulario Rent 2 Rent/Dispositivo_encendido.jpg"></v-img>
				</v-card>
			</v-dialog>

			<v-dialog v-model="modalDispositivoApagado" max-width="800">
				<v-card>
					<v-img src="/img/formulario Rent 2 Rent/Dispositivo_apagado.jpg"></v-img>
				</v-card>
			</v-dialog>


			<v-dialog v-model="modalCondiciones" max-width="800" scrollable>
				<v-card class="condiciones">
					<v-card-title>
						<v-row justify="space-between" no-gutters>
							<v-col class="azulClaro">CONDICIONES GENERALES DE LA ORDEN DE REPARACIÓN</v-col>
							<v-col cols="auto" @click="modalCondiciones = false">X</v-col>
						</v-row>
					</v-card-title>
					<v-card-text>
						<span class="azul">Telefónica Móviles España, S.A.U., en adelante “Movistar”, gestionará la reparación de tu dispositivo según las siguientes condiciones:</span>
						<ul>
							<li>Si lo has adquirido <b>en propiedad</b>: dispones de 3 años de garantía desde su entrega, conforme al Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el texto refundido de la Ley General para la Defensa de los Consumidores y Usuarios y otras leyes complementarias.</li>
							<li>Si disfrutas de él como parte del producto Fusión <b>en régimen de arrendamiento</b>: durante el mismo, tienes derecho a recibir un mantenimiento para su buen funcionamiento o a su sustitución por otro del mismo modelo o de similares características si no es posible su reparación y la avería no se debe a un mal uso por tu parte.</li>
							<li><b>En cualquier caso</b>: al firmar este documento, habilitas a Movistar o establecimientos autorizados por Movistar, a tramitar la reparación del dispositivo con el servicio técnico homologado del fabricante, según la normativa aplicable al servicio de reparación de aparatos de uso doméstico.</li>
						</ul>
						<span class="azul">Debes tener en cuenta que no están cubiertos, en ningún caso, los daños originados por: </span>
						<ul>
							<li>Un mal trato o uso negligente (ej.: caídas o circunstancias de uso distintas al uso ordinario y habitual).</li>
							<li>La manipulación del dispositivo por tu cuenta o por un tercero no autorizado.</li>
							<li>La instalación de programas no realizados o no aprobados por Movistar.</li>
							<li>Un caso fortuito (ej.: descarga atmosférica, incendio, inundación o variaciones excesivas de la red eléctrica).</li>
						</ul>
						<span class="azul">Tienes que entregarnos tu dispositivo cumpliendo estos requisitos:</span>
						<ul>
							<li>En su <b>caja original</b>: junto con su albarán de entrega donde conste su código de identificación (ej.: IMEI).</li>
							<li><b>Sin accesorios</b> (tapas de batería, punteros, tarjetas de memoria, SIM…): no nos responsabilizamos de su pérdida o deterioro.</li>
							<li><b>Sin información</b>: es tu obligación entregar el dispositivo sin ningún contendido. Antes de entregárnoslo, asegura que has guardado tus datos personales, fotos, vídeos y cualquier contenido valioso para ti. Actualizaremos el software y no nos hacemos responsables de la pérdida total o parcial de la información que pudieras tener en el dispositivo.</li>
							<li><b>Sin bloqueos</b>: tienes que entregarnos el dispositivo sin ningún código de seguridad que impida acceder al mismo (huella, reconocimiento facial, contraseña…). Si no, no nos responsabilizamos de las consecuencias de devolverte el dispositivo sin haberlo podido reparar.</li>
						</ul>
						<span class="azul">Si la reparación es incompatible con el régimen de garantía o de mantenimiento que te aplique o simplemente quieres reparar tu dispositivo:</span>
						<ul>
							<li>Te facilitaremos un <b>presupuesto de reparación</b> válido durante 30 días hábiles desde su entrega. Si lo aceptas, procederemos con la reparación y si lo rechazas, te facturaremos 5 € por gastos de gestión (6,05 con IVA, 5,35 con IGIC, 5,50 con IPSI Ceuta y 5,40 con IPSI Melilla.). Si no es reparable, te lo devolveremos sin coste.</li>
							<li>Incluiremos los <b>gastos de reparación o de gestión</b> en tu factura Movistar si ya eres cliente, y si aún no lo eres, tendrás que pagarlos mediante transferencia bancaria o ingreso en la cuenta que te indicarán en la tienda, o llamando al 91 696 97 68.</li>
							<li>Si la avería <b>no es reparable</b>, podrás ir a recoger tu dispositivo a la tienda sin ningún coste.</li>
						</ul>
						<span class="azul">Tratamiento de tus datos personales:</span>
						<ul>
							<li>Trataremos tus datos personales conforme a lo establecido en la Política de Privacidad de Movistar, cuya información básica se recoge aquí. Dispones de su contenido íntegro en: www.movistar.es/privacidad. Telefónica de España, S.A.U. y Telefónica Móviles España, S.A.U., del grupo Telefónica, son las empresas corresponsables del tratamiento de tus datos personales, según los productos o servicios que tengas contratados.</li>
							<li>Trataremos tus datos para la prestación del Servicio, así como para otras finalidades que, como cliente Movistar, nos permitas o autorices en los términos recogidos en la Política de Privacidad, en la que además se recoge toda la información necesaria para que puedas decidir sobre otros tratamientos que requieran tu consentimiento. Los datos personales necesarios que aportas en este acto para la ejecución del contrato, junto a los obtenidos con motivo de la prestación del Servicio, así como a través de los canales de atención y comercialización, se incluirán en ficheros informatizados de datos de carácter personal titularidad de Movistar.</li>
							<li>Adicionalmente a los tratamientos recogidos en la Política de Privacidad, al aceptar los presentes términos y condiciones de uso del Servicio, eres informado y autorizas a Movistar al tratamiento específico de los datos facilitados en estas condiciones de reparación, en concreto, tus datos de cliente y del dispositivo averiado, cuyo tratamiento es necesario para la prestación del servicio de reparación.</li>
							<li>Para cualquier finalidad prevista en nuestra política de privacidad, Movistar puede encargar el tratamiento a proveedores de confianza y a aquellos que realizan transferencias internacionales de datos en el ejercicio de sus funciones recogidos en www.movistar.es/privacidad/info-adicional. En este sentido, garantizamos la adopción de las medidas necesarias para asegurar el tratamiento confidencial de dichos datos.</li>
							<li>Si lo deseas, puedes ejercer los derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad mandándonos un email a TE_datos@telefonica.com con el asunto DATOS, enviando un escrito al Apartado de Correos 46155, 28080 Madrid, o llamándonos al número gratuito 224407.</li>
						</ul>
						<v-btn @click="enviar" color="#9be51a" x-large block>
							<span style="color:black; font-weight:bold">ACEPTAR CONDICIONES Y ENVIAR</span>
						</v-btn>
					</v-card-text>
				</v-card>
			</v-dialog>
		</section>

		<footer>
			<div style="height: 30px"></div>
			<div class="bloque-alerta">
				<span id="lblMensaje12"></span>
			</div>
		</footer>
	</div>
</template>

<script>
	import incidencia_formulario from "@/Modelos/IncidenciaFormulario";
	import comprobaciones from "@/plugins/comprobaciones.js";

	export default {
		//layout: "noZeleris",
		layout: "movistar",
		components: {
			inputFile: () => import("@/components/fusion/input-file"),
			menuPage: () => import("@/components/movistar/menu"),
		},
		created() {
			this.formulario = incidencia_formulario;
			this.formulario.idOrigen = 1
			this.getDesplegables();
		},

		data: () => ({
			//Iniciales
			TiposModelos: undefined,
			Fabricantes: undefined,
			Modelos: undefined,
			modalSN: false,
			modalEmbalaje1: false,
			modalEmbalaje2: false,
			modalEmbalaje3: false,
			modalEmbalaje4: false,
			modalDispositivoEncendido: false,
			modalDispositivoApagado: false,
			modalIMEI: false,
			modalCondiciones: false,
			//Flujo
			pedirDesplegables: {
				idTipoModelo: null,
				idMarca: null,
			},
			localTelefono: "",
			errorTelefono: "",
			localAbonado: "",
			errorAbonado: "",
			localEmail: "",
			errorEmail: "",
			localDNI: "",
			errorDNI: "",
			localHorario: "",
			observacionesContacto: "",
			localHorarioDesde: "",
			localHorarioHasta: "",
			erroresObligatorios: {
				nombre: "",
				sintoma: "",
				direccion: "",
				cp: "",
				poblacion: "",
				albaran: "",
				horarioContacto: "",
				dondeVenta: "",
				familia: "",
				marca: "",
				modelo: "",
				embalaje1: "",
				embalaje2: "",
				embalaje3: "",
				embalaje4: "",
				dispositivo_encendido: "",
				dispositivo_apagado: "",
				dispositivo: "",
				caja_carga: "",
				serial_number: "",
			},
			//Final
			formulario: {},
			enviandoIncidencia: false,
			incidencia: "",
			tipoTextoIncidencia: "",

			toggle_exclusive: "",
			itemsHorariosDesde: ['8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'],
			itemsHorariosHasta: ['8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'],

			itemsDondeVenta: ["Entregada en mi domicilio", "Recogida en la tienda"],
		}),

		watch: {
			pedirDesplegables: {
				deep: true,
				handler(valor) {
					this.getDesplegables();
				},
			},
			localHorarioHasta(nuevo) {
				if (nuevo != "" && this.localHorarioDesde != "")
					this.formulario.metaData.horarioContacto =
						"Desde " + this.localHorarioDesde + " hasta " + nuevo;
			},
			localHorarioDesde(nuevo) {
				this.localHorarioHasta = "";
				if (nuevo == undefined && nuevo == "") {
					this.localHorarioHasta = "";
				} else {
					Object.assign(this.itemsHorariosHasta, this.itemsHorariosDesde);
					this.itemsHorariosHasta = this.itemsHorariosHasta.splice(this.itemsHorariosDesde.indexOf(nuevo) + 1, this.itemsHorariosDesde.length);
				}
			}
		},

		computed: {
			formularioCompleto() {

				var foto = false;


				// AIRPODS 209 ; FRIGORIFICO 212 ; LAVADORA 214; SMARTPHONE 1; PANELES SOLARES 215;
				// MONITOR 19 ; PORTATIL 2; SMARTWATCH 23; TABLET 21; TV 3;
				//AIRFRYER 216; ASPIRADORA 211; BARRA SONIDO 210; CAFETERA 47; CONSOLA 205; GAFAS VR 183; LAVAVAJILLAS 213; PATINETE 206; ROUTER 203; SECADOR 73;VIDEOCONSOLA 164
				if (this.pedirDesplegables.idTipoModelo == 212 || this.pedirDesplegables.idTipoModelo == 214
					|| this.pedirDesplegables.idTipoModelo == 215 || this.pedirDesplegables.idTipoModelo == 1) {
					foto = true;
				}


				else if (this.pedirDesplegables.idTipoModelo == 216 || this.pedirDesplegables.idTipoModelo == 211 ||
					this.pedirDesplegables.idTipoModelo == 210 || this.pedirDesplegables.idTipoModelo == 47 ||
					this.pedirDesplegables.idTipoModelo == 205 || this.pedirDesplegables.idTipoModelo == 183 ||
					this.pedirDesplegables.idTipoModelo == 213 || this.pedirDesplegables.idTipoModelo == 206 ||
					this.pedirDesplegables.idTipoModelo == 203 || this.pedirDesplegables.idTipoModelo == 73 ||
					this.pedirDesplegables.idTipoModelo == 164) {
					foto = this.formulario.embalaje1 != null &&
						this.formulario.embalaje1 != "" &&
						this.formulario.embalaje2 != null &&
						this.formulario.embalaje2 != "" &&
						this.formulario.embalaje3 != null &&
						this.formulario.embalaje3 != "" &&
						this.formulario.embalaje4 != null &&
						this.formulario.embalaje4 != "" &&
						this.formulario.dispositivo != null &&
						this.formulario.dispositivo != "" &&
						this.formulario.serial_number != null &&
						this.formulario.serial_number != ""

				}

				else if (this.pedirDesplegables.idTipoModelo == 19 || this.pedirDesplegables.idTipoModelo == 2 ||
					this.pedirDesplegables.idTipoModelo == 23 || this.pedirDesplegables.idTipoModelo == 21 ||
					this.pedirDesplegables.idTipoModelo == 3) {
					foto = this.formulario.embalaje1 != null &&
						this.formulario.embalaje1 != "" &&
						this.formulario.embalaje2 != null &&
						this.formulario.embalaje2 != "" &&
						this.formulario.embalaje3 != null &&
						this.formulario.embalaje3 != "" &&
						this.formulario.embalaje4 != null &&
						this.formulario.embalaje4 != "" &&
						this.formulario.dispositivo_encendido != null &&
						this.formulario.dispositivo_encendido != "" &&
						this.formulario.dispositivo_apagado != null &&
						this.formulario.dispositivo_apagado != "" &&
						this.formulario.serial_number != null &&
						this.formulario.serial_number != ""

				}


				else if (this.pedirDesplegables.idTipoModelo == 209) {
					foto = this.formulario.caja_carga != null &&
						this.formulario.caja_carga != "" &&
						this.formulario.dispositivo != null &&
						this.formulario.dispositivo != ""
				}

				else {
					foto = false;
				}

				/*if (this.pedirDesplegables.idTipoModelo == null || this.pedirDesplegables.idMarca == null
					 || this.formulario.idModelo == null) {
					 foto = false;
					 alert('sin datos');
				 }
				 alert(this.pedirDesplegables.idTipoModelo);
				 alert(this.pedirDesplegables.idMarca);
				 alert(this.formulario.idModelo);*/

				return (
					this.formulario.metaData.numeroAbonadoCliente != null &&
					this.formulario.metaData.numeroAbonadoCliente != "" &&
					this.formulario.metaData.dniCliente != null &&
					this.formulario.metaData.dniCliente != "" &&
					this.formulario.metaData.nombreCliente != null &&
					this.formulario.metaData.nombreCliente != "" &&
					this.formulario.metaData.emailCliente != null &&
					this.formulario.metaData.emailCliente != "" &&
					this.formulario.linea.sintomaAveria != null &&
					this.formulario.linea.sintomaAveria != "" &&
					this.formulario.metaData.direccionCliente != null &&
					this.formulario.metaData.direccionCliente != "" &&
					this.formulario.metaData.cpCliente != null &&
					this.formulario.metaData.cpCliente != "" &&
					this.formulario.metaData.poblacionCliente != null &&
					this.formulario.metaData.poblacionCliente != "" &&
					this.formulario.metaData.horarioContacto != null &&
					this.formulario.metaData.horarioContacto != "" &&
					this.formulario.metaData.dondeVenta != null &&
					this.formulario.metaData.dondeVenta != "" &&
					this.pedirDesplegables.idTipoModelo != null &&
					this.pedirDesplegables.idMarca != null &&
					this.formulario.idModelo != null &&
					foto


				);
			},
		},

		methods: {
			getDesplegables() {
				this.$API.getDesplegables(this.pedirDesplegables).then((response) => {
					if (response.hasOwnProperty("tiposModelos")) {
						this.TiposModelos = response.tiposModelos;
						if (response.tiposModelos.length == 1)
							this.pedirDesplegables.idTipoModelo = response.tiposModelos[0].ID;
					}
					if (response.hasOwnProperty("marcas")) {
						this.Fabricantes = response.marcas;
						if (response.marcas.length == 1)
							this.pedirDesplegables.idMarca = response.marcas[0].ID;
					}

					if (response.hasOwnProperty("modelos")) {
						this.Modelos = response.modelos;
						if (response.modelos.length == 1)
							this.formulario.idModelo = response.modelos[0].ID;
					}
				});
			},

			changeSelectFamilia() {



				this.pedirDesplegables.idMarca = null;
				this.formulario.idModelo = null;
				this.formulario.embalaje1 = null;
				this.formulario.embalaje2 = null;
				this.formulario.embalaje3 = null;
				this.formulario.embalaje4 = null;
				this.formulario.dispositivo = null;
				this.formulario.dispositivo_apagado = null;
				this.formulario.dispositivo_encendido = null;
				this.formulario.caja_carga = null;
				this.formulario.serial_number = null;

				document.getElementById("embalaje1").value = "";
				document.getElementById("embalaje2").value = "";
				document.getElementById("embalaje3").value = "";
				document.getElementById("embalaje4").value = "";
				document.getElementById("dispositivo").value = "";
				document.getElementById("dispositivo_apagado").value = "";
				document.getElementById("dispositivo_encendido").value = "";
				document.getElementById("caja_carga").value = "";
				document.getElementById("serial_number").value = "";
				//vaciarCampos();
			},

			changeSelectMarca() {

				if (this.pedirDesplegables.idTipoModelo == 1 && this.pedirDesplegables.idMarca == 77) {
					if (window.confirm('Para poder recogerse el dispositivo tiene que estar desactivada la función Buscar Mi iPhone. Si necesita ayuda, pulse aceptar para leer el documento')) {
						window.open('/doc/Desactivar_Buscar_iPhone_2020.pdf', '_blank');
					};
				}
				/*<a href="/doc//doc/Desactivar_Buscar_iPhone_2020.pdf" target="_blank">
					<span style="col or:black; font-weight:bold">LEER Y ACEPTAR CONDICIONES   </span>
				</a>*/

				this.formulario.idModelo = null;
			},

			//Validaciones de campos
			comprobarCampos() {
				//this.comprobarTelefono();
				this.comprobarAbonado();
				this.comprobarDNI();
				this.comprobarEmail();
				this.comprobarObligatorios();

				if (!this.formularioCompleto) window.scrollTo(0, 0);
				else this.modalCondiciones = true
			},
			comprobarDNI() {
				let comprobacionesjs = new comprobaciones();
				this.formulario.metaData.dniCliente = "";
				this.errorDNI = "";
				if (this.localDNI == "")
					this.errorDNI =
						"El campo <b>'DNI'</b> es obligatorio y no puede estar vacío";
				else if (!comprobacionesjs.isDNI(this.localDNI) && !comprobacionesjs.isNIE(this.localDNI) && !comprobacionesjs.isCIF(this.localDNI) && !comprobacionesjs.isTR(this.localDNI) && !comprobacionesjs.isPassport(this.localDNI))
					this.errorDNI =
						"El campo <b>'DNI/CIF/TARJETA RESIDENTE/PASAPORTE'</b> no tiene un formato correcto.";
				else this.formulario.metaData.dniCliente = this.localDNI;
			},
			comprobarTelefono() {
				this.formulario.metaData.telefonoCliente = "";
				this.errorTelefono = "";
				if (this.localTelefono == "")
					this.errorTelefono =
						"El campo <b>'Teléfono de Contacto'</b> es obligatorio y no puede estar vacío";
				else if (!/^[0-9]{9}/.test(this.localTelefono))
					this.errorTelefono =
						"El campo <b>'Teléfono de Contacto'</b> no tiene un formato correcto, 9 dígitos númericos sin espacios";
				else this.formulario.metaData.telefonoCliente = this.localTelefono;
			},
			comprobarAbonado() {
				this.formulario.metaData.numeroAbonadoCliente = "";
				this.errorAbonado = "";
				if (this.localAbonado == "")
					this.errorAbonado =
						"El campo <b>'Número de Abonado'</b> es obligatorio y no puede estar vacío";
				else if (!/^[0-9]{9}/.test(this.localAbonado))
					this.errorAbonado =
						"El campo <b>'Número de Abonado'</b> no tiene un formato correcto, 9 dígitos númericos sin espacios";
				else this.formulario.metaData.numeroAbonadoCliente = this.localAbonado;
			},
			comprobarEmail() {
				this.formulario.metaData.emailCliente = "";
				this.errorEmail = "";
				if (this.localEmail == "")
					this.errorEmail =
						"El campo <b>'Email'</b> es obligatorio y no puede estar vacío";
				else if (!this.localEmail.includes("@") || !this.localEmail.includes("."))
					this.errorEmail =
						"El campo <b>'Email'</b> no tiene un formato de email válido";
				else this.formulario.metaData.emailCliente = this.localEmail;
			},
			comprobarObligatorios() {
				Object.entries(this.erroresObligatorios).forEach(([key, value]) => {
					this.erroresObligatorios[key] = "";
				});
				if (
					this.formulario.metaData.nombreCliente == null ||
					this.formulario.metaData.nombreCliente == ""
				)
					this.erroresObligatorios.nombre =
						"El campo <b>'Nombre'</b> es obligatorio y no puede estar vacío";
				if (
					this.formulario.linea.sintomaAveria == null ||
					this.formulario.linea.sintomaAveria == ""
				)
					this.erroresObligatorios.sintoma =
						"El campo <b>'Descripción Avería'</b> es obligatorio y no puede estar vacío";
				if (
					this.formulario.metaData.direccionCliente == null ||
					this.formulario.metaData.direccionCliente == ""
				)
					this.erroresObligatorios.direccion =
						"El campo <b>'Dirección'</b> es obligatorio y no puede estar vacío";
				if (
					this.formulario.metaData.cpCliente == null ||
					this.formulario.metaData.cpCliente == ""
				)
					this.erroresObligatorios.cp =
						"El campo <b>'Código Postal'</b> es obligatorio y no puede estar vacío";
				if (
					this.formulario.metaData.poblacionCliente == null ||
					this.formulario.metaData.poblacionCliente == ""
				)
					this.erroresObligatorios.poblacion =
						"El campo <b>'Población'</b> es obligatorio y no puede estar vacío";
				if (
					this.formulario.metaData.horarioContacto == null ||
					this.formulario.metaData.horarioContacto == ""
				)
					this.erroresObligatorios.horarioContacto =
						"Los campos <b>'HORARIO DESDE'</b> y <b>'HORARIO HASTA'</b> son obligatorios y no pueden estar vacíos";
				if (
					this.formulario.metaData.dondeVenta == null ||
					this.formulario.metaData.dondeVenta == ""
				)
					this.erroresObligatorios.dondeVenta = "El campo <b>'La venta del dispositivo se ha efectuado con'</b> es obligatorio y no puede estar vacío"

				if (
					this.pedirDesplegables.idTipoModelo == null ||
					this.pedirDesplegables.idTipoModelo == ""
				)
					this.erroresObligatorios.familia = "El campo <b>'Familia'</b> es obligatorio y no puede estar vacío"

				if (
					this.pedirDesplegables.idMarca == null ||
					this.pedirDesplegables.idMarca == ""
				)
					this.erroresObligatorios.marca = "El campo <b>'Marca'</b> es obligatorio y no puede estar vacío"

				if (
					this.formulario.idModelo == null ||
					this.formulario.idModelo == ""
				)
					this.erroresObligatorios.modelo = "El campo <b>'Modelo'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo != 209 && this.pedirDesplegables.idTipoModelo != 212 &&
					this.pedirDesplegables.idTipoModelo != 214 && this.pedirDesplegables.idTipoModelo != 1 &&
					this.pedirDesplegables.idTipoModelo != 215) &&
					(this.formulario.embalaje1 == null ||
						this.formulario.embalaje1 == "")
				)
					this.erroresObligatorios.embalaje1 = "El campo <b>'Embalaje 1'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo != 209 && this.pedirDesplegables.idTipoModelo != 212 &&
					this.pedirDesplegables.idTipoModelo != 214 && this.pedirDesplegables.idTipoModelo != 1 &&
					this.pedirDesplegables.idTipoModelo != 215) &&
					(this.formulario.embalaje2 == null ||
						this.formulario.embalaje2 == "")
				)
					this.erroresObligatorios.embalaje2 = "El campo <b>'Embalaje 2'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo != 209 && this.pedirDesplegables.idTipoModelo != 212 &&
					this.pedirDesplegables.idTipoModelo != 214 && this.pedirDesplegables.idTipoModelo != 1 &&
					this.pedirDesplegables.idTipoModelo != 215) &&
					(this.formulario.embalaje3 == null ||
						this.formulario.embalaje3 == "")
				)
					this.erroresObligatorios.embalaje3 = "El campo <b>'Embalaje 3'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo != 209 && this.pedirDesplegables.idTipoModelo != 212 &&
					this.pedirDesplegables.idTipoModelo != 214 && this.pedirDesplegables.idTipoModelo != 1 &&
					this.pedirDesplegables.idTipoModelo != 215) &&
					(this.formulario.embalaje4 == null ||
						this.formulario.embalaje4 == "")
				)
					this.erroresObligatorios.embalaje4 = "El campo <b>'Embalaje 4'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo == 19 || this.pedirDesplegables.idTipoModelo == 2 ||
					this.pedirDesplegables.idTipoModelo == 23 || this.pedirDesplegables.idTipoModelo == 21 ||
					this.pedirDesplegables.idTipoModelo == 3) &&
					(this.formulario.dispositivo_encendido == null ||
						this.formulario.dispositivo_encendido == "")
				)
					this.erroresObligatorios.dispositivo_encendido = "El campo <b>'Dispositivo Encendido'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo == 19 || this.pedirDesplegables.idTipoModelo == 2 ||
					this.pedirDesplegables.idTipoModelo == 23 || this.pedirDesplegables.idTipoModelo == 21 ||
					this.pedirDesplegables.idTipoModelo == 3) &&
					(this.formulario.dispositivo_apagado == null ||
						this.formulario.dispositivo_apagado == "")
				)
					this.erroresObligatorios.dispositivo_apagado = "El campo <b>'Dispositivo Apagado'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo == 216 || this.pedirDesplegables.idTipoModelo == 209 || this.pedirDesplegables.idTipoModelo == 211 ||
					this.pedirDesplegables.idTipoModelo == 210 || this.pedirDesplegables.idTipoModelo == 47 || this.pedirDesplegables.idTipoModelo == 205 ||
					this.pedirDesplegables.idTipoModelo == 183 || this.pedirDesplegables.idTipoModelo == 213 || this.pedirDesplegables.idTipoModelo == 206 ||
					this.pedirDesplegables.idTipoModelo == 203 || this.pedirDesplegables.idTipoModelo == 73 || this.pedirDesplegables.idTipoModelo == 164) &&
					(this.formulario.dispositivo == null ||
						this.formulario.dispositivo == "")
				)
					this.erroresObligatorios.dispositivo = "El campo <b>'Dispositivo'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo == 209) &&
					(this.formulario.caja_carga == null ||
						this.formulario.caja_carga == "")
				)
					this.erroresObligatorios.caja_carga = "El campo <b>'Caja Carga'</b> es obligatorio y no puede estar vacío"

				if ((this.pedirDesplegables.idTipoModelo != 209 && this.pedirDesplegables.idTipoModelo != 212 &&
					this.pedirDesplegables.idTipoModelo != 214 && this.pedirDesplegables.idTipoModelo != 1 &&
					this.pedirDesplegables.idTipoModelo != 215) &&
					(this.formulario.serial_number == null ||
						this.formulario.serial_number == "")
				)
					this.erroresObligatorios.serial_number = "El campo <b>'Serial Number'</b> es obligatorio y no puede estar vacío"
			},

			//envio final
			enviar() {
				if (!this.enviandoIncidencia) {
					this.incidencia = "";
					this.enviandoIncidencia = true;
					this.$API
						.resgistarIncidencia({
							formulario: this.formulario,
							familia: this.pedirDesplegables.idTipoModelo,
						})
						.then((response) => {
							if (response.codigo == 0) {
								if (response.incidencia === undefined) {
									this.tipoTextoIncidencia = "warning";
									this.incidencia = response.mensaje;
								} else {
									this.tipoTextoIncidencia = "success";
									this.incidencia =
										"Se ha generado la incidencia '" +
										response.incidencia +
										"' para tratar su gestión";
								}
								this.vaciarCampos();
							} else {
								this.tipoTextoIncidencia = "warning";
								this.incidencia =
									"Ha habido un error al crear la incidencia. Por favor, intentelo de nuevo más tarde";
							}
							window.scrollTo(0, 0);
							this.enviandoIncidencia = false;
							this.modalCondiciones = false;
						});
				}
			},
			vaciarCampos() {
				this.localTelefono = "";
				this.localAbonado = "";
				this.localEmail = "";
				this.pedirDesplegables.idTipoModelo = null;
				this.pedirDesplegables.idMarca = null;
				this.formulario = incidencia_formulario;
			},
		},
		mounted() {
            this.$router.push('informacion');
			//window.location.href = 'https://www.vatservices.es';
		}
	};
</script>

<style>
	.informacion {
		color: #869296;
		font-size: 20px;
	}

		.informacion:hover {
			color: rgb(78, 168, 0);
		}

	.condiciones .azulClaro {
		color: #A6DDFB;
	}

	.condiciones .azul {
		color: #019DF4;
	}

	.condiciones ul {
		padding-left: 20px;
		padding-bottom: 10px;
		list-style: none;
	}

		.condiciones ul li::before {
			content: "\2022";
			color: #019DF4;
			font-weight: bold;
			display: inline-block;
			width: 1em;
			margin-left: -1em;
		}
</style>